const features = [
  {
    title: "Shard + Index で JSON 分解",
    body: "スライド単位の JSON + 目次 (INDEX.md) + スキーマ (SCHEMA.md) を自動生成。AI が必要な部分だけ読める構造。",
  },
  {
    title: "レイアウト解析ビューアー",
    body: "ページごとに色分けの境界ボックス・AI 向け要約・構造 JSON で、テキスト/図表/写真の位置と種別を可視化。",
  },
  {
    title: "PDF 対応 & PowerPoint 生成",
    body: "PPTX に加えて PDF もアップロード可能。PDF の解析結果から、編集可能な PowerPoint を新規生成できます。",
  },
  {
    title: "theme / master まで埋め込み",
    body: "PPTX 固有の配色・レイアウトを JSON 内に自己完結。テンプレが手元になくても復元可能。",
  },
  {
    title: "階層折りたたみビューア",
    body: "長文は 1000 文字で省略、検索とノード単位コピーに対応。レイアウト解析と同じファイルを共有して行き来できます。",
  },
  {
    title: "分割パック ZIP / フラット JSON",
    body: "AI に渡すなら ZIP、シンプル派には単一 JSON。両方サポート。",
  },
];

export function Features() {
  return (
    <section className="mx-auto max-w-6xl px-5 py-12 sm:px-6 sm:py-16">
      <h2 className="mb-8 font-display text-2xl font-medium sm:mb-12 sm:text-3xl">特徴</h2>
      <div className="grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
        {features.map((f) => (
          <div
            key={f.title}
            className="rounded-[14px] border border-[var(--color-border)] bg-[var(--color-surface)] p-6 shadow-[var(--shadow-sm)] sm:p-7"
          >
            <h3 className="mb-2 font-display text-lg font-medium sm:mb-3 sm:text-xl">{f.title}</h3>
            <p className="text-sm leading-relaxed text-[var(--color-ink-muted)]">{f.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
